import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Alert, Button } from "components/bootstrap";
import { Icon, ConfirmDialog } from "components/common";
import useProductName from "brand-customization/useProductName";
const StyledAlert = styled(Alert)`
  padding: ${({ theme }) => theme.spacings.lg};
  margin: ${({ theme }) => theme.spacings.md};
  margin-top: 0;
`;
const Banner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const LeftItems = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacings.md};
`;
const BoldText = styled.h1`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.variant.danger};
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.md};
  width: ${({ $width }) => $width || "auto"};
  align-items: ${({ $align }) => $align || "flex-start"};
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  ${({ $justify }) => $justify ? css`
          justify-content: ${$justify};
        ` : css`
          gap: ${({ theme }) => theme.spacings.md};
        `}
  width: ${({ $fullWidth }) => $fullWidth ? "100%" : "auto"};
`;
const StyledIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.variant.danger};
`;
const LEFT_COLUMN_ITEM_LIST = [
  "anomaly_detection_ai",
  "cloud_option",
  "archiving",
  "audit_logs_cloud",
  "dynamic_lookup_tables",
  "advanced_alerting",
  "compliance_reporting",
  "correlation_aggregation",
  "threat_intel"
];
const RIGHT_COLUMN_ITEM_LIST = [
  "incident_workspaces",
  "prebuilt_parser_dashboards",
  "sigma_rules",
  "parameterized_dashboards",
  "input_output_integrations",
  "threat_management",
  "search_workflow",
  "soar_integrations"
];
const TeaserPageLayout = ({ children }) => {
  const { t } = useTranslation("users");
  const productName = useProductName();
  const [showModal, setShowModal] = useState(true);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "info", noIcon: true }, /* @__PURE__ */ React.createElement(Banner, null, /* @__PURE__ */ React.createElement(LeftItems, null, /* @__PURE__ */ React.createElement(BoldText, null, t("security_teaser.demo.title")), /* @__PURE__ */ React.createElement("span", null, t("security_teaser.demo.banner_text", { productName }))), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", role: "link", target: "_blank", href: "https://graylog.org/explore-security/" }, t("security_teaser.demo.button", { productName }), " ", /* @__PURE__ */ React.createElement(Icon, { name: "open_in_new" })))), children, showModal && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      title: t("security_teaser.demo.title"),
      onConfirm: () => setShowModal(false),
      onCancel: () => setShowModal(false),
      btnConfirmText: t("common:actions.close")
    },
    /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement("h2", { className: "text-danger" }, t("security_teaser.demo.overview")), /* @__PURE__ */ React.createElement("p", null, t("security_teaser.demo.description", { productName })), /* @__PURE__ */ React.createElement(Row, { $justify: "space-between", $fullWidth: true }, /* @__PURE__ */ React.createElement(Col, null, LEFT_COLUMN_ITEM_LIST.map((item) => /* @__PURE__ */ React.createElement(Row, { key: item }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "check" }), /* @__PURE__ */ React.createElement("span", null, t(`security_teaser.demo.items.${item}`, { productName }))))), /* @__PURE__ */ React.createElement(Col, null, RIGHT_COLUMN_ITEM_LIST.map((item) => /* @__PURE__ */ React.createElement(Row, { key: item }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "check" }), /* @__PURE__ */ React.createElement("span", null, t(`security_teaser.demo.items.${item}`, { productName })))))))
  ));
};
export default TeaserPageLayout;
